import CommsPrefs from './CommsPrefs'

export default CommsPrefs
